/**
 * Map internal filters for being used from within `methods`. This makes them usable in js as well as templates
 * @param {Array} filters - A list of registered filter names
 * @return {Object) An object containing filters and their functions
 */
export function mapFilters(filters) {
    return filters.reduce((result, filter) => {
        result[filter] = function(...args) {
            return this.$options.filters[filter](...args);
        };
        return result;
    }, {});
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/vue/map-filters.js